import React from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

const Language: React.FC = () => {
    const { i18n } = useTranslation();
    const colors = useAppSelector(state => state.theme.colors);
    const textGrey = colors?.textSecondary || '#5f6368';

    return (
        <Button
            startIcon={<LanguageIcon fontSize="small" />}
            size="small"
            variant="text"
            onClick={() =>
                i18n.changeLanguage(i18n?.language.startsWith('en') ? 'fr-CA' : 'en')
            }
            sx={{
                mt: 2, // Reduced margin-top
                px: 1,
                minHeight: 32,
                color: textGrey,
                textTransform: 'none',
                backgroundColor: 'transparent',
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: 'transparent',
                    textDecoration: 'underline',
                    color: textGrey,
                },
                '&:focus': {
                    outline: 'none',
                    backgroundColor: 'transparent',
                    color: textGrey,
                },
                '& .MuiTouchRipple-root': { display: 'none' }
            }}
        >
            {i18n.language.startsWith('en') ? 'Français' : 'English'}
        </Button>
    );
};

export default Language;